export const ADD_USER_FAIL = "Add user fail!";
export const UPDATE_USER_FAIL = "Update user fail!";
export const ADD_DEPARTMENT_FAIL = "Add department fail!";
export const UPDATE_DEPARTMENT_FAIL = "Update department fail!";
